import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ecp-lender-contact-blocks',
  templateUrl: './lender-contact-blocks.component.html',
  styleUrls: ['./lender-contact-blocks.component.scss'],
  standalone: false
})
export class LenderContactBlocksComponent implements OnInit {
  /** Lender data */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() public lenderData: any;
  /** Optional boolean: Hide phone block */
  @Input() public hidePhone = false;
  /** Optional boolean: Hide SMS block */
  @Input() public hideChat = false;
  /** Optional boolean: Hide email block */
  @Input() public hideEmail = false;
  /** Optional boolean: Hide address block */
  @Input() public hideAddress = false;

  /** check if phone block has data to show */
  public phoneBlockHasData = false;
  /** check if email block has data to show */
  public emailBlockHasData = false;
  /** check if address block has data to show */
  public addressBlockHasData = false;

  public ngOnInit(): void {
    if (this.lenderData) {
      this.phoneBlockHasData =
        !this.hidePhone &&
        this.lenderData.isPhoneBlock &&
        (this.isValueExists(this.lenderData.hoursOfOperation) ||
          this.isValueExists(this.lenderData.daysOfOperation) ||
          this.isContactExists(this.contactInfoByType(this.lenderData.contacts, 'phone')));
      this.emailBlockHasData =
        !this.hideEmail && this.lenderData.isEmailBlock && this.isContactExists(this.contactInfoByType(this.lenderData.contacts, 'email'));
      this.addressBlockHasData =
        !this.hideAddress &&
        this.lenderData.isAddressBlock &&
        (this.isValueExists(this.lenderData.address1) ||
          this.isValueExists(this.lenderData.address2) ||
          this.isValueExists(this.lenderData.city) ||
          this.isValueExists(this.lenderData.state));
    }
  }

  public contactInfoByType(contacts, contactType) {
    const filteredContacts = contacts?.filter((contact) => contact?.type?.toLowerCase() === contactType && contact.value);
    return filteredContacts;
  }

  public isValueExists(value: string): boolean {
    return value ? true : false;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public isContactExists(arrayValue: any): boolean {
    return arrayValue && arrayValue.length > 0 ? true : false;
  }
}
